import React, { useState, useMemo, useEffect } from "react";

import { getOpenEvents } from "services/event.service";
import { useApp } from "context/appContext";
import {
  getReservationByPerson,
  cancelReservation,
} from "services/event.service";
import * as Status from "constants/statusBooking";
import { orderEvents } from "utils/eventsUtils";
import { isAdmin } from "services/auth.service";

const CancelContext = React.createContext();

export function CancelProvider(props) {
  const [groupId, setGroupId] = useState("");
  const [showForm, setShowForm] = useState(true);
  const [loading, setLoading] = useState(true);
  const [reservation, setReservation] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const { showNotification } = useApp();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    async function loadEvents() {
      const openEvents = await getOpenEvents();
      if (openEvents) {
        let eventsOrdered;
        if (isAdmin()) {
          eventsOrdered = orderEvents(openEvents);
        } else {
          eventsOrdered = orderEvents(
            openEvents.filter((event) => event.type !== "PRV")
          );
        }

        setEvents(
          eventsOrdered.map(({ description, id }) => ({
            value: id,
            label: description,
          }))
        );
      } else {
        setEvents([]);
      }
      setLoading(false);
    }

    loadEvents();
    // eslint-disable-next-line
  }, []);

  const getReservation = async (values) => {
    setLoading(true);
    try {
      const reservationInfo = await getReservationByPerson(values);
      setReservation(reservationInfo);
      setShowForm(false);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err.message);
      showNotification(
        "No se ha encontrado tu reserva, por favor contacta con el administrador",
        "error"
      );
    }
  };

  const onCancelReservation = async () => {
    setLoading(true);
    try {
      await cancelReservation(reservation);
      setReservation(null);
      setShowForm(true);
      setLoading(false);
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 2000);
    } catch (err) {
      setLoading(false);
      console.log(err.message);
      showNotification(
        "No ha sido posible cancelar tu reserva, por favor contacta con el administrador.",
        "error"
      );
    }
  };

  const handleEditItem = (id, value) => {
    let clone = JSON.parse(JSON.stringify(reservation));
    clone.assistants.forEach((assistant) => {
      if (assistant.id === id) {
        assistant.state = value ? Status.PENDING : Status.RESERVED;
      }
    });
    setReservation(clone);
  };

  // eslint-disable-next-line
  const value = useMemo(() => {
    return {
      groupId,
      loading,
      showForm,
      reservation,
      showSuccess,
      events,
      setReservation,
      setShowForm,
      setGroupId,
      setLoading,
      getReservation,
      setShowSuccess,
      onCancelReservation,
      handleEditItem,
    };
  });

  return <CancelContext.Provider value={value} {...props} />;
}

export function useCancel() {
  const context = React.useContext(CancelContext);
  if (!context) {
    throw new Error("useCancel debe estar dentro del proveedor CancelContext");
  }
  return context;
}
